export default "__VITE_ASSET__C2Bdxbp3__"